import React from 'react';
import SimpleTextLink from '../../core/common/SimpleTextLink';
import SimpleThemer from 'app/ui/config/SimpleThemer';

export default class ErrorPageLink extends React.Component {
  render() {
    return (
      <SimpleThemer
        mergeClasses="ErrorPageLink"
        color="common.ErrorPageLink"
        render={c => <SimpleTextLink {...this.props} className={c} />}
      />
    );
  }
}
